export const CLOSE_DROPDOWN_CONTEXT_NAME = "Toolbar:DropdownWrapper:closeDropdown";
export const UPDATE_DROPDOWN_STYLE_CONTEXT_NAME = "Toolbar:DropdownWrapper:updateDropdownStyle";
